import React, { useState } from "react";
import { Navbar, Nav, NavDropdown, Container } from "react-bootstrap";
import "./Header.css";
import 'bootstrap/dist/css/bootstrap.min.css';

function Header() {
  const [showDropdown, setShowDropdown] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false); // Track if the menu is open

  const handleItemClick = () => {
    setShowDropdown(false);
    setMenuOpen(false); // Close the menu when an item is clicked
  };
  const toggleDropdown = () => setShowDropdown(prev => !prev);
  const toggleMenu = () => setMenuOpen(prev => !prev); // Toggle menu open state

  return (
    <Navbar
      expand="lg"
      bg="dark"
      variant="dark"
      sticky="top"
      className={`custom-header ${menuOpen ? "show" : ""}`} // Add 'show' class when menu is open
    >
      <Container>
        <Navbar.Brand href="/">
          <img
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/be7523a07c4c489d66cc1d63e48023131a4ba6fc?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b"
            alt="Website Logo"
            className="header-logo"
          />
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="navbar-nav"
          onClick={toggleMenu} // Toggle menu on click
          className="custom-toggle"
        />
        <Navbar.Collapse id="navbar-nav" className={menuOpen ? "show" : ""}>
          <Nav className="ms-auto navbar-nav" style={{ background: "none" }}>
            <div className="spacesforthis"></div>
            <NavDropdown
              title={<span>About Us</span>}
              onClick={toggleDropdown}
              id="about-us-dropdown"
              className="custom-dropdown"
              show={showDropdown}
              style={{ background: "none" }} // Set background color to black
            >
              <NavDropdown.Item style={{ backgroundColor: "transparent" }} href="/" onClick={handleItemClick}>
                Home
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href="/user" onClick={handleItemClick}>
                KIY - User
              </NavDropdown.Item>
              <NavDropdown.Divider className="dropdown-divider" />
              <NavDropdown.Item href="/partner" onClick={handleItemClick}>
                KIY - Partner
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href="/ecosystem" onClick={handleItemClick}>
                KIY - Ecosystem
              </NavDropdown.Item>
            </NavDropdown>
            <Nav.Link href="/authenticity-check" className="custom-link">
              Authenticity Check
            </Nav.Link>
            <Nav.Link href="/contactus" className="custom-link">
              Contact with us
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;
